<template>

  <v-select 
    :value="selected"
    @input="change"
    :options="options"
    :placeholder="placeholder">
    </v-select>

</template>

<script>
export default {
  name: 'SelectUser',
  props: {
    'value': {
      type: [String, Object],
      default: null
    },
    'placeholder': {
      type: String,
      default: null
    },
    'active': {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      'members': []
    }
  },
  computed: {
    valueId () {
      return this.value && this.value._id ? this.value._id : this.value
    },
    options () {
      return this.members.map((val) => {
        return {
          label: val.user_id.name,
          value: val.user_id._id
        }
      })
    },
    selected () {
      return this.options.find((val) => {
        return val.value === this.valueId
      })
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.$store
      .dispatch('getMembers', {sort: 'name', limit: 1000, active: this.active})
      .then((result) => {
        this.members = result.docs
      })
    },
    change (val) {
      const value = val ? val.value : null
      if (value !== this.valueId) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fields/SelectUser.vue